export default "__VITE_ASSET__9ac4800d__"